const scrollers = gsap.utils.toArray('h-scroller') || [];
scrollers.forEach(scroller => {
  
  let triggerElement = scroller;
  let trigger = scroller.dataset.trigger;

  if(trigger){
    triggerElement = scroller.closest(trigger);
  }

  let triggerStart = scroller.dataset.triggerStart || 'top';
  let triggerEnd = scroller.dataset.triggerEnd || 'bottom';
  let viewportStart = scroller.dataset.viewportStart || 'center';
  let viewportEnd = scroller.dataset.viewportEnd || 'center';
  let from = parseInt(scroller.dataset.from) || -50;
  let to = parseInt(scroller.dataset.to) || 100;

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: triggerElement,
      start: triggerStart+" "+viewportStart,
      end: triggerEnd+" "+viewportEnd,
      scrub: true
    }
  });
  tl.from(scroller, {
    xPercent: from,
    ease: "none"
  });
  tl.to(scroller, {
    xPercent: to,
    ease: "none"
  });
});